/**
 * Check if the browser supports Video alpha channel.
 * This is necessary to properly render videos with transparent backgrounds.
 * @returns boolean
 */
export default function supportsAlphaChannel(): boolean {
  if (typeof navigator === 'undefined') {
    return true
  }

  // Assume that devices not running iOS supports it.
  if (/iP(hone|od|ad)/.test(navigator.userAgent) === false) {
    return true
  }

  const versionMatcher = /OS (\d+)_(\d+)_?(\d+)?/
  const version = navigator.userAgent.match(versionMatcher)

  if (version) {
    const majorVersion = parseInt(version[1], 10)

    if (majorVersion >= 13) {
      return true
    }
  }

  return false
}
